query findContacts($channels: [ID], $roles: [ID], $productTypes: [ID], $showInactive: Boolean) {
  findContacts(channels: $channels, roles: $roles, productTypes: $productTypes, showInactive: $showInactive)
}
